"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToggleSwitch;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @ts-ignore: Unreachable code error

function ToggleSwitch(props) {
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Toggle, {
    id: "default-toggle",
    dataSelectorPrefix: "barring-management-toggle-switch-".concat(props.barNumber),
    name: "the-default-toggle",
    value: "toggle-1",
    isActive: props.active,
    onChange: props.onchange
  });
}